/**
 * Surface split A1 (Danna 25.09): has THIS device ever rendered the app home?
 * A local device flag on purpose, not a server field: the first sign-in on a
 * new phone opens her results, every later one opens home as before.
 */
const KEY = 'mk_home_shown_v1';

export function homeShownOnDevice(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return true; // storage unavailable: keep the existing home landing
  }
}

export function markHomeShownOnDevice(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {}
}
